import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import ModalSubmit from "components/common/ModalSubmit";
import Modal from "./Modal";
import BootstrapModalWrapper from "./BootstrapModalWrapper";
const BootstrapModalForm = ({
  backdrop = void 0,
  submitButtonDisabled = false,
  formProps = {},
  bsSize = void 0,
  show,
  submitButtonText = void 0,
  onSubmitForm = void 0,
  onCancel,
  title,
  children,
  ...restProps
}) => {
  const { t } = useTranslation("common");
  const form = useRef(null);
  const submit = (event) => {
    event.stopPropagation();
    const formDOMNode = form.current;
    if (typeof formDOMNode.checkValidity === "function" && !formDOMNode.checkValidity()) {
      event.preventDefault();
      return;
    }
    if (typeof onSubmitForm === "function") {
      event.preventDefault();
      onSubmitForm(event);
    }
  };
  const body = /* @__PURE__ */ React.createElement("div", { className: "container-fluid" }, children);
  return /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { bsSize, showModal: show, backdrop, onHide: onCancel, ...restProps }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, title)), /* @__PURE__ */ React.createElement("form", { ref: form, onSubmit: submit, ...formProps, "data-testid": "modal-form" }, /* @__PURE__ */ React.createElement(Modal.Body, null, body), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      disabledSubmit: submitButtonDisabled,
      onCancel,
      submitButtonText: submitButtonText != null ? submitButtonText : t("actions.submit")
    }
  ))));
};
export default BootstrapModalForm;
